import requireAll from '../requireAll';

import './_module';

// NOTE: no need to require the ./constants folder, because it is completely converted to TypeScript and will be
// imported when you import the 'nv.shared.constants.module.ts' file. As other sub-folders are converted to TypeScript,
// they should also be removed from this file, too.
requireAll(require.context('./background-job-ui', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./components', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./directives', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./error-handling', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./filters', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./modals', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./models', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
import './services';
requireAll(require.context('./static-models', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
